import { render, staticRenderFns } from "./ClientContractsDialog.vue?vue&type=template&id=3ba4e165&scoped=true&"
import script from "./ClientContractsDialog.vue?vue&type=script&lang=ts&"
export * from "./ClientContractsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ClientContractsDialog.vue?vue&type=style&index=0&id=3ba4e165&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba4e165",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VDivider,VRow})
